"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecordDisciplineProperty = exports.recordDisciplinePropertyDefinition = void 0;
exports.recordDisciplinePropertyDefinition = {
    view: { label: 'Discipline' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'record-discipline',
};
const isRecordDisciplineProperty = (prop) => {
    return prop.name === exports.recordDisciplinePropertyDefinition.name;
};
exports.isRecordDisciplineProperty = isRecordDisciplineProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjb3JkLWRpc2NpcGxpbmUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZWNvcmQtZGlzY2lwbGluZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxZQUFZLEVBQUU7SUFDN0IsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLG1CQUFtQjtDQUNNLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==